
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

const PAGINATION_CONTROL_CLASS = "pagination-control";

@Component({
  components: {},
})
export default class UploaderPDFPreview extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly preview?;

  params: any = {};

  @Watch("preview", { immediate: true })
  previewChanged(payload) {
    this.params = payload;
  }

  updateParams() {
    this.$emit("update-preview", this.params);
  }

  setPageCount(payload) {
    this.params.pageCount = payload;
  }

  setCurrentPage(payload) {
    this.params.currentPage = payload;
  }

  get zoomLevel() {
    return `${this.params.zoom}%`;
  }

  updateCurrentPage(val) {
    const { currentPage, pageCount } = this.params;

    const newCurrentPage = currentPage + val;

    if (newCurrentPage > pageCount) {
      this.params.currentPage = pageCount;

      return;
    }

    if (newCurrentPage < 1) {
      this.params.currentPage = 1;

      return;
    }

    this.params.currentPage = newCurrentPage;

    this.updateParams();
  }

  get prevPageDisabled() {
    const { currentPage } = this.params;

    const newCurrentPage = currentPage - 1;

    return newCurrentPage < 1;
  }

  get prevPaginationControlClasses() {
    return {
      [`${PAGINATION_CONTROL_CLASS}_disabled`]: this.prevPageDisabled,
    };
  }

  get nextPageDisabled() {
    const { currentPage, pageCount } = this.params;

    const newCurrentPage = currentPage + 1;

    return newCurrentPage > pageCount;
  }

  get nextPaginationControlClasses() {
    return {
      [`${PAGINATION_CONTROL_CLASS}_disabled`]: this.nextPageDisabled,
    };
  }
}
